var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"infoTravel",attrs:{"cols":"12","md":"11","id":"info"},domProps:{"innerHTML":_vm._s(_vm.desc)}})}
var staticRenderFns = []

export { render, staticRenderFns }